import formStep from "./formStep.component";

const formStepModule = angular
  .module("app.components.formStep", [])
  .component("formStep", formStep);

export default formStepModule;



// WEBPACK FOOTER //
// ./src/components/formStep/formStep.module.js